// TODO: 스마트 컨트랙트를 실제 세폴리아 테스트넷에 배포한 후 아래 주소를 교체해 주세요.
export const VOTING_CONTRACT_ADDRESS = "0x66c367c7dF25F9C3781783bA2bc7cF1eff82acad";

export const VOTING_CONTRACT_ABI = [
  "function startVoting(uint256 _durationInDays)",
  "function checkVotingActive() view returns (bool)",
  "function startTime() view returns (uint256)",
  "function endTime() view returns (uint256)",
  "function isVotingPaused() view returns (bool)",
  "function isVotingEnded() view returns (bool)",
  "function getAllCandidates() view returns (tuple(uint256 id, string name, string photoUrl, uint256 voteCount)[])",
  "function vote(uint256 _candidateId)",
  "function hasVoted(address) view returns (bool)",
  "function isWhitelisted(address) view returns (bool)",
  "function owner() view returns (address)",
  "function addCandidate(string calldata _name, string calldata _photoUrl)",
  "function addVotersToWhitelist(address[] calldata _voters)",
  "function setManualPause(bool _paused)",
  "function forceEndVoting()",
  "function transferOwnership(address newOwner)"
];